var ManageProfileImage = React.createClass({
  propTypes: {
    user: React.PropTypes.object.isRequired
  },
  render() {
    const {user} = this.props;
    const avatarPath = Config.contextPath + RA.defaultAvatar(user.avatar);
    const profileImagePath = this.props.user.avatar;
    const profileText = this.props.user.initials;

    const renderProfileImage = () => {
      if (RA.Utils.isNotBlank(profileImagePath)) {
        return (
              <img src={avatarPath} alt={user.username} className="user-image__avatar"/>
        );
      }

      if (RA.Utils.isNotBlank(profileText)) {
        return (
              <span className="user-image__avatar avatar-text-alt">{profileText}</span>
        );
      }
    }

    return (
      <div className="user-image -lg">
        {renderProfileImage()}
        <div><a href={`${Config.contextPath}/app/portlets/usermanagement/update-avatar.jsp`} target="_blank" rel="opener"><span className="sr-only">{Labels.getLabel("New Window")}</span>{Labels.getLabel("Change")}</a></div>
      </div>
    )
  }
});